module.exports = __webpack_public_path__ + "static/media/portfolio6.e1f14fb4.png";